import { get, post } from '@/helpers/httpHandler';
import { PermissionsService } from '@/services/permissions/permissions.service';
import { createMongoAbility } from '@casl/ability';
import { defaultChannel, echo } from '@/helpers/pusher';

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem('api_token') || null,
    user: localStorage.getItem('user') || null,
    permissions: localStorage.getItem('permissions') || null,
    ability: createMongoAbility(() => {})
  },

  getters: {
    hasToken: state => {
      return state.token !== null;
    },

    user: state => {
      return JSON.parse(state.user);
    },

    ability: state => {
      return state.ability;
    },

    hasAbility: state => {
      return state.ability.j && state.ability.j.length;
    }
  },

  mutations: {
    retrievedToken: (state, token) => {
      localStorage.setItem('api_token', token);
      state.token = token;
    },

    destroyedToken: state => {
      localStorage.removeItem('locale');
      localStorage.removeItem('api_token');
      localStorage.removeItem('user');
      state.token = null;
      state.user = null;
    },

    retrievedUser: (state, user) => {
      localStorage.setItem('user', user);
      state.user = user;
    },

    retrievedAbility: (state, permissions) => {
      let rules = permissions.map(v => {
        return { action: v.slug };
      });

      state.ability.update(rules);
    }
  },

  actions: {
    retrieveToken: ({ commit }, credentials) => {
      return post('/auth/user/login', credentials).then(response => {
        const { api_token, user } = response.data;

        commit('retrievedToken', api_token);
        commit('retrievedUser', JSON.stringify(user));

        return response;
      });
    },

    destroyToken: () => {
      return post('/auth/user/logout');
    },

    retrieveUserInfo: () => {
      return get('/user');
    },

    retrievePermissions: ({ commit, getters: { user } }, userId = user.id) => {
      return PermissionsService.getUserPermissions(userId).then(response => {
        console.log('retrievePermissions', response.data.data);
        commit('retrievedAbility', response.data.data);

        return response;
      });
    },

    getActualPermissions({ commit, getters: { user } }, userId = user.id) {
      return echo
        .channel(`permission-user.${userId}`)
        .listen('.App\\Events\\User\\UpdatePermission', function(data) {
          console.log('getActualPermissions', data);
          commit('retrievedAbility', data.permissions);
        });
    }
  }
};
